/* Toogle */
const sizeSwitch = document.getElementById('input-size-switch');
const inchLabel = document.getElementById('inchLabel');
const cmLabel = document.getElementById('cmLabel');

sizeSwitch.addEventListener('click', checkMode);

function checkMode() {
  const cellValues = document.querySelectorAll('.measure__table_td:not(.ignore-conv)');

  if (sizeSwitch.checked) {
    inchLabel.classList.remove('active');
    cmLabel.classList.add('active');

    cellValues.forEach((cell) => {
      let value = cell.innerHTML.trim().replace(/&nbsp;/g, '');
      let numbers = value.split('-');
      let convertedNumbers = [];

      for (let index = 0; index < numbers.length; index++) {
        let number = parseFloat(numbers[index]);
        let convertedNumber = number * 2.54;
        convertedNumber = convertedNumber.toFixed(0);
        convertedNumbers.push(convertedNumber);
      }
      let html = convertedNumbers.join('-');
      cell.innerHTML = html;
    });
  } else {
    inchLabel.classList.add('active');
    cmLabel.classList.remove('active');

    cellValues.forEach((cell) => {
      let value = cell.innerHTML.trim().replace(/&nbsp;/g, '');
      let numbers = value.split('-');
      let convertedNumbers = [];

      for (let index = 0; index < numbers.length; index++) {
        let number = parseFloat(numbers[index]);
        let convertedNumber = number * 0.39370079;
        convertedNumber = convertedNumber.toFixed(1);
        convertedNumbers.push(convertedNumber);
      }
      let html = convertedNumbers.join('-');
      html = html.split('.0').join('');
      cell.innerHTML = html;
    });
  }
}
